import styled from '@emotion/styled';

import IconExclamationCircled from 'components/icons/exclamationCircled';

export const Wrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: 14,
  fontWeight: 500,
  margin: '150px 0',
  color: theme.colors.inactive,
  gap: 24,
  textAlign: 'center',
}));

export const Icon = styled(IconExclamationCircled)(({ theme }) => ({
  width: 46,
  height: 46,
  '& path': {
    fill: theme.colors.inactive,
  },
}));
